import DeviceDetection from 'oc-commons/DeviceDetection.js';

/**
 * IOS 10 safari ingoriert user-scalable=no, hiermit wird es wieder eigeschaltet.
 * Funktioniert, indem alle Zoom/Pinch-Gesten ausgeschaltet werden.
 * Leider kann der User manchmal doch noch in den Zoommodus gelangen, aber wenn das so ist,
 * wird es erkannt und man kann ab da die IOS-Zoomgesten wieder frei verwenden, bis man wieder in die normale
 * Ansicht zurückgezoomed hat.
 */
if (DeviceDetection.isIOS() && /user-scalable\s*=\s*no/.test($('meta[name=viewport]').attr('content'))) {
    const isUnZoomed = ()=> {
        const physicalWidth = Math.abs(window.orientation)==90 ? window.screen.height : window.screen.width;
        const zoomedWidth1 = document.body.clientWidth;
        const zoomedWidth2 = window.innerWidth;
        return zoomedWidth1 == zoomedWidth2 && zoomedWidth1 == physicalWidth;
    }
    $(document).on('gesturestart', (e)=>{
        if (isUnZoomed()) {
            e.preventDefault();
        }
    });
    $(document).on('touchstart', (e)=>{
        if (e.touches && e.touches.length > 1) {
            if (isUnZoomed()) {
                e.preventDefault();
            }
        }
    });
    let lastTouchEnd = 0;
    $(document).on('touchend', (e)=>{
        const now = performance.now();
        if (now - lastTouchEnd <= 300) {
            if (isUnZoomed()) {
                e.preventDefault();
            }
        }
        lastTouchEnd = now;
    });
}